import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import FreeAgencyPage from './FreeAgencyPage';
import { supabase } from '../services/supabase';

export default function FreeAgencyPageWrapper() {
  const { leagueId } = useParams<{ leagueId: string }>();
  const navigate = useNavigate();
  const [teamId, setTeamId] = React.useState<string>('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const loadTeamId = async () => {
      const userId = localStorage.getItem('userId');
      if (userId && leagueId) {
        const { data } = await supabase
          .from('teams')
          .select('id')
          .eq('league_id', leagueId)
          .eq('owner_id', userId)
          .single();
        if (data) setTeamId(data.id);
      }
      setLoading(false);
    };
    loadTeamId();
  }, [leagueId]);

  if (loading) return <div>Loading free agency...</div>;
  if (!leagueId || !teamId) return <div>No team found in this league.</div>;

  return (
    <FreeAgencyPage
      leagueId={leagueId}
      teamId={teamId}
      onBack={() => navigate(-1)}
    />
  );
}
